export default __webpack_public_path__ + "static/media/thermalprinter.fd025898.svg";